import { render } from "./Mansoura University Hospital.vue?vue&type=template&id=275acc5f&scoped=true"
const script = {}

import "./Mansoura University Hospital.vue?vue&type=style&index=0&id=275acc5f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-275acc5f"

export default script